var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultiSelect',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    value: _vm.tooltip,
    disabled: _vm.tooltip === '',
  }),expression:"{\n    value: tooltip,\n    disabled: tooltip === '',\n  }",modifiers:{"top":true}}],class:{
    'bank-picker': true,
    'p-invalid': _vm.invalid,
  },attrs:{"options":_vm.options,"disabled":_vm.disabled,"option-label":"label","option-value":"value","append-to":"body","placeholder":_vm.placeholder || _vm.$t('bankPicker.placeholder'),"filter":""},model:{value:(_vm.chosen),callback:function ($$v) {_vm.chosen=$$v},expression:"chosen"}})}
var staticRenderFns = []

export { render, staticRenderFns }